import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c5db600")

_pushScopeId("data-v-2c5db600")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Leverage Adjustment")
const _hoisted_2 = { class: "tabs-wrap df-middle" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Adjustment")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Learn about leverage")
const _hoisted_5 = { class: "btn-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_TheAdjustment = _resolveComponent("TheAdjustment")
  const _component_TheLeverLearn = _resolveComponent("TheLeverLearn")
  const _component_Button = _resolveComponent("Button")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, {
    class: "bg-white",
    useFooter: _ctx.activeIndex===0
  }, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "leverage_2" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          class: ["submit-btn f-lg f-bold btn", {'primary':_ctx.submitActive}],
          onClick: _ctx.confirmSubmit
        }, {
          default: _withId(() => [
            _createVNode(_component_t, {
              path: "leverage_11",
              custom: ""
            }, {
              default: _withId(({td}) => [
                _createTextVNode(_toDisplayString(td || 'Submit the adjustment'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class", "onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: ["tab-item flex-1 df-center", {'active':_ctx.activeIndex===0}],
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabChange()))
          }, [
            _createVNode(_component_t, { path: "leverage_3" }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ], 2),
          _createVNode("div", {
            class: ["tab-item flex-1 df-center", {'active':_ctx.activeIndex===1}],
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tabChange()))
          }, [
            _createVNode(_component_t, { path: "leverage_4" }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ], 2)
        ]),
        (_ctx.activeIndex===0)
          ? (_openBlock(), _createBlock(_component_TheAdjustment, { key: 0 }))
          : (_openBlock(), _createBlock(_component_TheLeverLearn, { key: 1 }))
      ])
    ]),
    _: 1
  }, 8, ["useFooter"]))
})